import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppLocalizationService } from '@app/shared/common/localization/app-localization.service';
import { AppNavigationService } from '@app/shared/layout/nav/app-navigation.service';
import { INTIMECommonModule } from '@shared/common/common.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { CommonLookupModalComponent } from './lookup/common-lookup-modal.component';
import { EntityTypeHistoryModalComponent } from './entityHistory/entity-type-history-modal.component';
import { EntityChangeDetailModalComponent } from './entityHistory/entity-change-detail-modal.component';
import { DateRangePickerInitialValueSetterDirective } from './timing/date-range-picker-initial-value.directive';
import { DatePickerInitialValueSetterDirective } from './timing/date-picker-initial-value.directive';
import { DateTimeService } from './timing/date-time.service';
import { TimeZoneComboComponent } from './timing/timezone-combo.component';
import { CustomizableDashboardComponent } from './customizable-dashboard/customizable-dashboard.component';
import { WidgetGeneralStatsComponent } from './customizable-dashboard/widgets/widget-general-stats/widget-general-stats.component';
import { DashboardViewConfigurationService } from './customizable-dashboard/dashboard-view-configuration.service';
import { GridsterModule } from '@shared/compat';
import { WidgetDailySalesComponent } from './customizable-dashboard/widgets/widget-daily-sales/widget-daily-sales.component';
import { WidgetEditionStatisticsComponent } from './customizable-dashboard/widgets/widget-edition-statistics/widget-edition-statistics.component';
import { WidgetHostTopStatsComponent } from './customizable-dashboard/widgets/widget-host-top-stats/widget-host-top-stats.component';
import { WidgetIncomeStatisticsComponent } from './customizable-dashboard/widgets/widget-income-statistics/widget-income-statistics.component';
import { WidgetMemberActivityComponent } from './customizable-dashboard/widgets/widget-member-activity/widget-member-activity.component';
import { WidgetProfitShareComponent } from './customizable-dashboard/widgets/widget-profit-share/widget-profit-share.component';
import { WidgetRecentTenantsComponent } from './customizable-dashboard/widgets/widget-recent-tenants/widget-recent-tenants.component';
import { WidgetRegionalStatsComponent } from './customizable-dashboard/widgets/widget-regional-stats/widget-regional-stats.component';
import { WidgetSalesSummaryComponent } from './customizable-dashboard/widgets/widget-sales-summary/widget-sales-summary.component';
import { WidgetSubscriptionExpiringTenantsComponent } from './customizable-dashboard/widgets/widget-subscription-expiring-tenants/widget-subscription-expiring-tenants.component';
import { WidgetTopStatsComponent } from './customizable-dashboard/widgets/widget-top-stats/widget-top-stats.component';
import { FilterDateRangePickerComponent } from './customizable-dashboard/filters/filter-date-range-picker/filter-date-range-picker.component';
import { AddWidgetModalComponent } from './customizable-dashboard/add-widget-modal/add-widget-modal.component';
import { PieChartModule, AreaChartModule, LineChartModule, BarChartModule } from '@swimlane/ngx-charts';
import { NgxBootstrapDatePickerConfigService } from '@assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { PerfectScrollbarModule, CountoModule } from '@shared/compat';
import { AppBsModalModule } from '@shared/common/appBsModal/app-bs-modal.module';
import { SingleLineStringInputTypeComponent } from './input-types/single-line-string-input-type/single-line-string-input-type.component';
import { ComboboxInputTypeComponent } from './input-types/combobox-input-type/combobox-input-type.component';
import { CheckboxInputTypeComponent } from './input-types/checkbox-input-type/checkbox-input-type.component';
import { MultipleSelectComboboxInputTypeComponent } from './input-types/multiple-select-combobox-input-type/multiple-select-combobox-input-type.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PasswordInputWithShowButtonComponent } from './password-input-with-show-button/password-input-with-show-button.component';
import { KeyValueListManagerComponent } from './key-value-list-manager/key-value-list-manager.component';
import { SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClickOutsideModule } from 'ng-click-outside';
import { ProjectFilterComponent } from './filters/project-filter/project-filter.component';
import { OrganizationUnitFilterComponent } from './filters/organization-unit-filter/organization-unit-filter.component';
import { MemberFilterComponent } from './filters/member-filter/member-filter.component';
import { RoleFilterComponent } from './filters/role-filter/role-filter.component';
import { ModalPopupComponent } from './modal-popup/modal-popup/modal-popup.component';
import { ModalDeletePopupComponent } from './modal-popup/modal-delete-popup/modal-delete-popup.component';
import { TeamdashboardComponent } from './customizable-dashboard/teamdashboard/teamdashboard.component';
import { DateConvertPipePipe } from './Pipes/date-convert-pipe.pipe';
import { AddTaxesSettingComponent } from './add-taxes-setting/add-taxes-setting.component';
import { CountryDropdownComponent } from './common-dropdowns/country-dropdown/country-dropdown.component';
import { TimezoneDropdownComponent } from './common-dropdowns/timezone-dropdown/timezone-dropdown.component';
import { ModalSignupwarningPopupComponent } from './modal-popup/modal-signupwarning-popup/modal-signupwarning-popup.component';
import { TooltipModule as PrimeNgTooltipModule } from "primeng/tooltip";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { WarningModalPopupComponent } from './modal-popup/warning-modal-popup/warning-modal-popup.component';
import { SaveCancelComponent } from './save-cancel/save-cancel.component';
import { ProfileImageChainComponent } from './profile-image-chain/profile-image-chain.component';
import { SingleUserImageComponent } from './profile-image-chain/single-user-image/single-user-image.component';
import { DrawerModule } from 'primeng/drawer';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { ExportDropdownComponent } from './common-dropdowns/export-dropdown/export-dropdown.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalDeleteValidationComponent } from './modal-popup/modal-delete-validation/modal-delete-validation.component';
import { ModalPopupInviteUserComponent } from './modal-popup/modal-popup-invite-user/modal-popup-invite-user.component';
import { OrdinalDatePipe } from '@app/main/new-dashboard/Shared/Rank-pipe/ordinal-date.pipe';
import { NewExportDropdownComponent } from './common-dropdowns/new-export-dropdown/new-export-dropdown.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ItpProgressBarComponent } from './itp-progress-bar/itp-progress-bar.component';
import { TableColumnDateFilterComponent } from './filters/table-column-date-filter/table-column-date-filter.component';
import { FilterService } from 'primeng/api';
import { registerTableFilterMatchers } from './filters/table-column-date-filter/table-filter.util';


@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        ClickOutsideModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        UtilsModule,
        INTIMECommonModule,
        TableModule,
        PaginatorModule,
        GridsterModule,
        TabsModule,
        BsDropdownModule,
        PieChartModule,
        AreaChartModule,
        LineChartModule,
        BarChartModule,
        BsDatepickerModule,
        PerfectScrollbarModule,
        CountoModule,
        AppBsModalModule,
        AutoCompleteModule,
        TooltipModule,
        PrimeNgTooltipModule,
        DrawerModule,
        NgxShimmerLoadingModule,
        NgbModule,
        ProgressBarModule,
    ],
    declarations: [
        TimeZoneComboComponent,
        CommonLookupModalComponent,
        ProfileImageChainComponent,
        SingleUserImageComponent,
        EntityTypeHistoryModalComponent,
        EntityChangeDetailModalComponent,
        DateRangePickerInitialValueSetterDirective,
        DatePickerInitialValueSetterDirective,
        CustomizableDashboardComponent,
        WidgetGeneralStatsComponent,
        WidgetDailySalesComponent,
        WidgetEditionStatisticsComponent,
        WidgetHostTopStatsComponent,
        WidgetIncomeStatisticsComponent,
        WidgetMemberActivityComponent,
        WidgetProfitShareComponent,
        WidgetRecentTenantsComponent,
        WidgetRegionalStatsComponent,
        WidgetSalesSummaryComponent,
        WidgetSubscriptionExpiringTenantsComponent,
        WidgetTopStatsComponent,
        FilterDateRangePickerComponent,
        AddWidgetModalComponent,
        SingleLineStringInputTypeComponent,
        ComboboxInputTypeComponent,
        CheckboxInputTypeComponent,
        MultipleSelectComboboxInputTypeComponent,
        PasswordInputWithShowButtonComponent,
        KeyValueListManagerComponent,
        SubHeaderComponent,
        ProjectFilterComponent,
        OrganizationUnitFilterComponent,
        MemberFilterComponent,
        RoleFilterComponent,
        ModalPopupComponent,
        ModalDeletePopupComponent,
        TeamdashboardComponent,
        DateConvertPipePipe,
        AddTaxesSettingComponent,
        CountryDropdownComponent,
        TimezoneDropdownComponent,
        ModalSignupwarningPopupComponent,
        WarningModalPopupComponent,
        SaveCancelComponent,
        ExportDropdownComponent,
        ModalDeleteValidationComponent,
        ModalPopupInviteUserComponent,
        OrdinalDatePipe,
        NewExportDropdownComponent,
        ItpProgressBarComponent,
        TableColumnDateFilterComponent,
    ],
    exports: [
        INTIMECommonModule,
        TimeZoneComboComponent,
        CommonLookupModalComponent,
        EntityTypeHistoryModalComponent,
        EntityChangeDetailModalComponent,
        DateRangePickerInitialValueSetterDirective,
        DatePickerInitialValueSetterDirective,
        CustomizableDashboardComponent,
        ProfileImageChainComponent,
        SingleUserImageComponent,
        PasswordInputWithShowButtonComponent,
        KeyValueListManagerComponent,
        SubHeaderComponent,
        ProjectFilterComponent,
        OrganizationUnitFilterComponent,
        MemberFilterComponent,
        RoleFilterComponent,
        ModalPopupComponent,
        ModalDeletePopupComponent,
        AddTaxesSettingComponent,
        CountryDropdownComponent,
        ModalSignupwarningPopupComponent,
        SaveCancelComponent,
        ExportDropdownComponent,
        ModalDeleteValidationComponent,
        ModalPopupInviteUserComponent,
        OrdinalDatePipe,
        NewExportDropdownComponent,
        ItpProgressBarComponent,
        TableColumnDateFilterComponent,
    ],
    providers: [
        DateTimeService,
        AppLocalizationService,
        AppNavigationService,
        DashboardViewConfigurationService,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
    ]
})
export class AppCommonModule {
    constructor(filterService: FilterService) {
        registerTableFilterMatchers(filterService);
    }

    static forRoot(): ModuleWithProviders<AppCommonModule> {
        return {
            ngModule: AppCommonModule,
            providers: [AppAuthService, AppRouteGuard],
        };
    }
}
